<template>
    <div class="wall" v-if="menuLateralDrawer" @click="toggleMenu()">
        
    </div>
</template>
<script>
export default {
    //mixins:[mixin],
    name: 'wall',
    data () {
        return {   
            windowSize: {
                x: 0,
                y: 0,
            }       
        }
    },        
    methods:{
        toggleMenu(){
        //https://vuetifyjs.com/en/customization/breakpoints
        this.windowSize = { x: window.innerWidth, y: window.innerHeight };
        this.menuLateralDrawer = !this.menuLateralDrawer;    
        /*if (this.windowSize.x >= 600){
            this.menuLateralDrawer = !this.menuLateralDrawer;                        
            this.menuVerticalDrawer = true;
        } else {
            this.menuLateralDrawer = true;                        
            this.menuVerticalDrawer = !this.menuVerticalDrawer;
        }*/
        },
    },
    computed: {        
        menuLateralDrawer:{
            get(){
                return this.$store.state.menuLateralDrawer;
            },
            set(value){
                this.$store.state.menuLateralDrawer = value;
            }
        },
        menuVerticalDrawer:{
            get(){
                return this.$store.state.menuVerticalDrawer;
            },
            set(value){
                this.$store.state.menuVerticalDrawer = value;
            }
        }
    }
}
</script>
<style scoped>
.wall{
    width: 100%;
    height: 100%;
    position: fixed;
    background: darkgray;
    z-index: 90;
    opacity: 0.5 !important;
}
</style>